import { render, staticRenderFns } from "./ClinicDashboard.vue?vue&type=template&id=caff7052&scoped=true"
import script from "./ClinicDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClinicDashboard.vue?vue&type=style&index=0&id=caff7052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caff7052",
  null
  
)

export default component.exports